const checkUserMode = (): boolean => {
    try {
        return !!window.matchMedia('(prefers-color-scheme: dark)')
    } catch (error) { // eslint-disable-line local-rules/no-error-swallowing
        return false
    }
}

export const useDarkMode = () => ({
    checkUserMode,
})
